import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Tab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <ul className={styles.tab}>
                {content.map((item, index) => (
                    <li key={index} className="clearfix">
                        <div className={styles.pic}>
                            <a href={item.url} target="_blank">
                                <img src={item.image} />
                            </a>
                        </div>
                        <div className={styles.txt}>
                            <a href={item.url} target="_blank">
                                {item.title}
                            </a>
                        </div>
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(Tab);
